import { motion } from "framer-motion";
import { FiArrowRight, FiCheckCircle, FiExternalLink } from "react-icons/fi";
import { Link } from "react-router-dom";
import { websites } from "../../data/fakeData";
import SitePreview from "../UI/SitePreview";
import StarRating from "../UI/StarRating";

const FeaturedSites = () => {
  const featured = websites.filter((s) => s.featured).slice(0, 6);

  return (
    <section className="section-tinted">
      <div className="container-main py-20 lg:py-24">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-12"
        >
          <div>
            <div className="accent-line" />
            <p className="label-tag mb-2">Handpicked Selection</p>
            <h2 className="section-title">Featured Websites</h2>
            <p className="section-subtitle">
              Editor's choice — verified and reviewed by our expert team.
            </p>
          </div>
          <Link to="/websites" className="btn-ghost flex-shrink-0">
            View all websites <FiArrowRight size={14} />
          </Link>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {featured.map((site, i) => (
            <motion.div
              key={site.id}
              initial={{ opacity: 0, y: 25 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.07 }}
            >
              <Link
                to={`/website/${site.id}`}
                className="card-hover block group overflow-hidden h-full"
              >
                <SitePreview
                  url={site.url}
                  alt={site.name}
                  className="h-48"
                  imgClassName="group-hover:scale-105 transition-transform duration-700"
                />
                <div className="relative -mt-8 mx-4 z-10">
                  <div className="flex items-center justify-between">
                    <span className="bg-white/95 backdrop-blur-sm text-slate-700 text-[10px] font-semibold px-2.5 py-1 rounded-md shadow-sm border border-slate-200">
                      #{site.rank} — {site.category}
                    </span>
                    {site.featured && (
                      <span className="bg-amber-400 text-amber-950 text-[9px] font-bold px-2 py-0.5 rounded uppercase tracking-wider shadow-sm">
                        Featured
                      </span>
                    )}
                  </div>
                </div>
                <div className="p-5 pt-3">
                  <div className="flex items-start justify-between gap-2 mb-2">
                    <div className="flex items-center gap-1.5 min-w-0">
                      <h3 className="font-bold text-slate-900 text-base group-hover:text-indigo-600 transition-colors truncate">
                        {site.name}
                      </h3>
                      {site.verified && (
                        <FiCheckCircle
                          size={15}
                          className="text-indigo-500 flex-shrink-0"
                        />
                      )}
                    </div>
                    <FiExternalLink
                      size={14}
                      className="text-slate-300 group-hover:text-indigo-400 transition-colors flex-shrink-0 mt-0.5"
                    />
                  </div>
                  <p className="text-sm text-slate-500 leading-relaxed line-clamp-2 mb-4">
                    {site.description}
                  </p>
                  <div className="flex items-center justify-between pt-3 border-t-2 border-slate-100">
                    <div className="flex items-center gap-2">
                      <StarRating rating={site.rating} />
                      <span className="text-sm font-bold text-slate-900">
                        {site.rating}
                      </span>
                      <span className="text-xs text-slate-400 font-medium">
                        ({site.totalReviews.toLocaleString()})
                      </span>
                    </div>
                    <span className="text-xs text-slate-400 font-semibold">
                      {site.monthlyVisits}/mo
                    </span>
                  </div>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturedSites;
